import { Input } from "@/components/ui/input";
import DependentQuestions from "@/containers/survey/components/DependentQuestions";
import { useTranslation } from "react-i18next";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import { isRequired } from "@/lib/form";
import { cfg } from "@/schemas/question/cfg";

interface QuestionPicturesProps {
  index: number;
}

const QuestionPictures = ({ index }: QuestionPicturesProps) => {
  const { t } = useTranslation();

  return (
    <Fieldset>
      <Field
        name={`questions.${index}.cfg.minQuantity`}
        label={t("surveyEditor.picturesType.minQuantity")}
        required={isRequired(cfg.shape.minQuantity)}
        render={({ field }) => (
          <Input type="number" className="w-24" min={0} {...field} />
        )}
      />
      <Field
        name={`questions.${index}.cfg.maxQuantity`}
        label={t("surveyEditor.picturesType.maxQuantity")}
        required={isRequired(cfg.shape.maxQuantity)}
        render={({ field }) => (
          <Input type="number" className="w-24" min={0} {...field} />
        )}
      />
      <DependentQuestions index={index} />
    </Fieldset>
  );
};

export default QuestionPictures;
